import { useQuery } from "@tanstack/react-query";
import { getApiData } from "../helpers/AxiosInstance";

interface IUseGetHook {
  queryKey: string[];
  url: string;
  params: any;
}

const useGetHook = (props: IUseGetHook) => {
  const { queryKey, url, params } = props;
  const { isLoading, isError, data, isSuccess, refetch } = useQuery(
    queryKey,
    async () => {
      const response = await getApiData(url, params);
      return response.data;
    },
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );

  return { isLoading, isError, data, isSuccess, refetch };
};


export const useGetHookE = (props: IUseGetHook) => {
  const { queryKey, url, params } = props;
  const { isLoading, isError, data, isSuccess, refetch } = useQuery(
    queryKey,
    async () => {
      const response = await getApiData(url, params);
      return response.data;
    },
    {
      refetchOnWindowFocus: false,
      keepPreviousData: false,
    }
  );

  return { isLoading, isError, data, isSuccess, refetch };
};

export default useGetHook;
